<template>
  <div style="width:100%">
    <div class="activityDrawListHeader">
      <div class="activityDrawListHeader_title">
        {{ drawDetail.applyName }}
      </div>
      <div class="activityDrawListHeader_detail" style="margin-left:50px">
        <div class="activityDrawListHeader_detail_key">
          活動状态：
        </div>
        <div class="activityDrawListHeader_detail_value">
          {{
            drawDetail.applyStatus == "1"
              ? "未開始階段"
              : drawDetail.applyStatus == "2"
              ? "報名階段"
              : drawDetail.applyStatus == "3"
              ? "抽籤階段"
              : drawDetail.applyStatus == "4"
              ? "付款階段"
              : drawDetail.applyStatus == "5"
              ? "確認階段"
              : ""
          }}
        </div>
      </div>
      <div class="activityDrawListHeader_detail">
        <div class="activityDrawListHeader_detail_key">
          活動类型：
        </div>
        <div class="activityDrawListHeader_detail_value">
          {{
            drawDetail.applyWay == "1"
              ? "一般活動"
              : drawDetail.applyWay == "2"
              ? "演唱會"
              : drawDetail.applyWay == "4"
              ? "見面會"
              : drawDetail.applyWay == "3"
              ? "後臺活動"
              : ""
          }}
        </div>
      </div>
    </div>
    <div class="activityDrawListSearch timeWidth">
      <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForms searchFormPaddings"
          >
            <el-form-item label="會員帳號" class="searchItem">
              <el-input
                placeholder="请输入會員帳號"
                v-model="listMenuForm.userEmail"
              ></el-input>
            </el-form-item>
            <el-form-item label="地區" class="searchItem">
              <el-select
                v-model="listMenuForm.selectArea"
                placeholder="请选择地區"
                @change="selectAreaChange"
              >
                <el-option
                  v-for="item in Areaoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="詳細地區"
              v-if="listMenuForm.selectArea"
              class="searchItem"
            >
              <el-input
                v-model="listMenuForm.areaDetail"
                placeholder="請輸入詳細地址，如上海"
              ></el-input>
            </el-form-item>
            <el-form-item label="VIP開始日期早于" class="searchItems">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time1"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="VIP開始日期晚于"
              class="searchItems"
              v-if="showchange && !listMenuForm.selectArea"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time2"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="黑名單" class="searchItem" v-if="shouldlarge">
              <el-select
                v-model="listMenuForm.isBlack"
                placeholder="請選擇是否為黑名單"
              >
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchFormtwo">
            <el-form-item
              label="VIP開始日期晚于"
              class="searchItems"
              v-if="!showchange || listMenuForm.selectArea"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time2"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="報名狀態" class="searchItem">
              <el-select
                v-model="listMenuForm.selectStatus"
                placeholder="请选择報名狀態"
              >
                <el-option label="已抽中" value="1"></el-option>
                <el-option label="未抽中" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="黑名單" class="searchItem" v-if="!shouldlarge">
              <el-select
                v-model="listMenuForm.isBlack"
                placeholder="請選擇是否為黑名單"
              >
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="index == 0 ? '徽章' : ''"
              class="searchItem searchbage"
              v-for="(badges, index) in listMenuForm.badge"
              :key="index"
            >
              <el-select
                v-model="badges.badgeType"
                placeholder="請選擇徽章"
                @change="BadgeoptionsChange(badges.badgeType, index)"
              >
                <el-option
                  v-for="item in Badgeoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="badges.badgeLevel"
                placeholder="請選擇徽章等級"
                style="margin-left:10px"
              >
                <el-option
                  v-for="item in BadgeLeveloptions[index]"
                  :key="item.id"
                  :label="item.grade"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span
                v-show="!(index === 0)"
                style="color:#6C3DEA;cursor: pointer;"
                @click="
                  delGoodsItem(index, listMenuForm.badge, BadgeLeveloptions)
                "
                >删除</span
              >
              <i
                v-if="index === listMenuForm.badge.length - 1"
                class="el-icon-circle-plus-outline"
                @click="addbadges()"
              ></i>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="MenuBtnWrap_right">
        <div class="btn" @click="search()" style="marginRight:0.2rem">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
    </div>
    <div class="activityDrawListTag">
      <div class="activityDrawListTag_detail_key" style="margin-left:0px">
        登記人數：
      </div>
      <div class="activityDrawListTag_detail_value">
        {{ drawDetail.registration ? drawDetail.registration : 0 }}
      </div>
      <div class="activityDrawListTag_detail_key">
        活動名額數：
      </div>
      <div class="activityDrawListTag_detail_value">
        {{ drawDetail.totalNum ? drawDetail.totalNum : 0 }}
      </div>
      <div class="activityDrawListTag_detail_key">
        已抽中人數：
      </div>
      <div class="activityDrawListTag_detail_value">
        {{ drawDetail.selectionNumber ? drawDetail.selectionNumber : 0 }}
      </div>
    </div>
    <div class="activityDrawListTable">
      <div class="statusbar">
        <div class="statusbar_left">
          <div>已選擇（跨頁）</div>
          <div style="color:rgba(108, 61, 234, 1)">
            {{ checkboxList.length }} 項
          </div>
          <div
            style="color:rgba(108, 61, 234, 1);margin-left:27px;cursor:pointer"
            @click="showTipModal('in')"
          >
            中選
          </div>
          <div
            style="color:rgba(108, 61, 234, 1);margin-left:27px;cursor:pointer"
            @click="showTipModal('out')"
          >
            取消中選
          </div>
        </div>
        <div class="statusbar_right">
          <div class="btn" @click="showTipModal('back')">
            重新抽選
          </div>
          <div class="btn" @click="handleDownloadExcel">下載中選名單</div>
          <div class="btn" @click="showTipModal('update')">確認更新</div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          ref="multipleTable"
          height="660px"
          :data="tableData"
          style="width: 100%"
          :row-key="row => row.id"
          @select="handleSelect"
          @select-all="selectAll"
          @sort-change="handleSortChange"
          stripe
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            v-for="(item, index) in activityTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :sortable="item.sortable"
            :sort-by="['annualSelectNum', 'descending']"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop === 'status'">
                <div
                  v-if="scope.row.status == 1"
                  style="color:rgb(108, 61, 234)"
                >
                  已抽中
                </div>
                <div v-else>未抽中</div>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button @click="navigatetoDetail(scope.row)" type="text"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="currentPageSize"
          :page-sizes="[20, 50, 100, 200]"
          :pager-count="5"
          layout="sizes,prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示訊息"
      :visible.sync="confirmshow"
      width="5.6rem"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="closemodal"
    >
      <div
        style="marginTop:30px"
        :style="{ fontWeight: showKey == 'update' ? 500 : 400 }"
        class="commonfont"
      >
        {{ showTip }}
      </div>
      <div
        style="marginTop:5px"
        :style="{ fontWeight: showKey == 'update' ? 500 : 400 }"
        class="commonfont"
        v-if="showKey == 'back'"
      >
        {{ showTip2 }}
      </div>
      <div
        v-if="this.free == 1 && showKey == 'update'"
        style="margin-top: 10px;"
      >
        <span
          style="font-weight: 500;font-size: 14px;display: inline-block;margin-right: 15px;"
          class="commonfont"
          >請選擇付款結束時間</span
        >
        <el-date-picker
          v-model="paytime"
          type="datetime"
          placeholder="請選擇付款結束時間"
        >
        </el-date-picker>
      </div>
      <div
        v-if="showKey == 'update'"
        :style="{ marginTop: this.free == 1 ? '10px' : '5px' }"
        class="commonfont"
      >
        更新活動將進入確認階段並且無法在修改。 是否更新所有的報名狀態？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmshow = false">取消</el-button>
        <el-button type="primary" @click="confirmShowModal">{{
          showKey == "back"
            ? "確認返回"
            : showKey == "update"
            ? "確認更新"
            : "確認"
        }}</el-button>
      </span>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "活動 / 活動列表 ",
      navtitle: "活動抽簽",
      listMenuForm: {
        userEmail: "",
        // timeArr: [],
        // badgeLevel: "",
        // badgeType: "",
        time1: "",
        time2: "",
        badge: [
          {
            badgeLevel: "",
            badgeType: ""
          }
        ],
        selectStatus: "",
        selectArea: "",
        areaDetail: "",
        isBlack: ""
      },
      sortType: "",
      paytime: "",
      sortValue: "",
      dialogVisible: false,
      currentPage: 1, // 分页
      total: 10,
      currentPageSize: 20,
      checkboxList: [], //所有页面选中编号
      confirmshow: false, //确认弹窗
      showTip: "",
      showTip2: "",
      showKey: "",
      shouldlarge: true,
      activityTable: [
        {
          prop: "status",
          label: "報名狀態",
          width: "170"
        },
        {
          prop: "username",
          label: "會員帳號",
          width: "170"
        },
        {
          prop: "applicant",
          label: "申請人",
          width: "170"
        },
        {
          prop: "num",
          label: "張數",
          width: "110",
          sortable: "custom"
        },
        {
          prop: "district",
          label: "地區",
          width: "170"
        },
        {
          prop: "vipStartTime",
          label: "VIP起始日",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "vipEndTime",
          label: "VIP到期日",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "annualSelectNum",
          label: "本年度中選次數",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "sameTypeSelectNum",
          label: "同類型中選次數",
          width: "150",
          sortable: "custom"
        },
        {
          prop: "remark",
          label: "報名備註",
          width: "250"
        }
      ],
      //地区选择框
      Areaoptions: [
        {
          value: "1",
          label: "中國大陸"
        },
        {
          value: "2",
          label: "港澳臺"
        },
        {
          value: "3",
          label: "海外"
        }
      ],
      //徽章选择框
      Badgeoptions: [],
      BadgeLeveloptions: [{}],
      BadgeoptionsSum: [],
      tableData: [],
      drawDetail: {},
      isActivate: false, //详情缓存，非详情手刷
      showchange: true,
      free: ""
    };
  },
  created() {
    this.initpage();
    //手动清除整个页面，从列表处打开需要触发
    this.$bus.$on("activityDrawinit", () => {
      Object.assign(this.$data, this.$options.data());
      this.isActivate = false;
      this.initpage();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  destroyed() {},
  activated() {
    if (this.isActivate) {
      this.initpage();
    }
  },
  deactivated() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleDownloadExcel() {
      let _this = this;
      let param = {
        applyId: this.$route.query.id,
        status: 1
      };
      if (_this.listMenuForm.userEmail) {
        param = {
          ...param,
          username: _this.listMenuForm.userEmail
        };
      }
      if (_this.listMenuForm.time1 && _this.listMenuForm.time2) {
        let startTime = this.$formatDate(_this.listMenuForm.time1);
        let endTime = this.$formatDate(_this.listMenuForm.time2);
        param = {
          ...param,
          vipStartTime: startTime,
          vipEndTime: endTime
        };
      }
      let badgeId = [];
      if (_this.listMenuForm.badge[0].badgeType) {
        for (let i = 0; i < _this.listMenuForm.badge.length; i++) {
          if (!_this.listMenuForm.badge[i].badgeLevel) {
            this.dialogVisible = true;
            this.$propMessage("選擇徽章後請選擇徽章等級", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else {
            badgeId.push(_this.listMenuForm.badge[i].badgeLevel);
            param = {
              ...param,
              badgeId: badgeId.toString()
            };
          }
        }
      }

      if (_this.listMenuForm.selectArea) {
        param = {
          ...param,
          district: Number(_this.listMenuForm.selectArea),
          address: _this.listMenuForm.areaDetail
            ? _this.listMenuForm.areaDetail
            : null
        };
      }
      if (_this.listMenuForm.isBlack) {
        param = {
          ...param,
          blackList: Number(_this.listMenuForm.isBlack)
        };
      }
      if (_this.sortValue !== "") {
        param = {
          ...param,
          [_this.sortType]: _this.sortValue
        };
      }
      let url = "/request/apply/export/excel/status";
      let date = new Date();
      _this.$exportExcel(
        url,
        "POST",
        param,
        "中選名單" + this.$formatDate(date).substring(0, 10)
      );
    },
    closemodal() {
      // console.log(111);
      this.paytime = "";
    },
    delGoodsItem(index, list, list2) {
      list.splice(index, 1);
      list2.splice(index, 1);
    },
    addbadges() {
      const _this = this;
      let length = _this.listMenuForm.badge.length;
      _this.listMenuForm.badge.push({
        badgeLevel: "",
        badgeType: ""
      });
      _this.BadgeLeveloptions.push({});
    },
    initpage() {
      // this.BadgeInit()
      this.getList();
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    },
    handleResize() {
      let a =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.shouldlarge = a > 1919;
      this.showchange = a > 1500;
    },
    //徽章处理
    BadgeInit() {
      this.$get("/request/badge/all").then(res => {
        if (res.code == "00000") {
          this.BadgeoptionsSum = res.data;
          let current = [];
          res.data.forEach(item => {
            current.push({ label: item.name, value: item.name });
          });
          this.Badgeoptions = current;
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    getList() {
      let _this = this;
      let param = {
        applyId: this.$route.query.id,
        annualOrder: 1
      };
      if (_this.listMenuForm.userEmail) {
        param = {
          ...param,
          username: _this.listMenuForm.userEmail
        };
      }
      // 開始時間
      if (_this.listMenuForm.time1) {
        let startTime = this.$formatDate(_this.listMenuForm.time1);
        param = {
          ...param,
          vipStartTime: startTime
        };
      }
      // 結束時間
      if (_this.listMenuForm.time2) {
        let endTime = this.$formatDate(_this.listMenuForm.time2);
        param = {
          ...param,
          vipEndTime: endTime
        };
      }
      // 徽章
      let badgeId = [];
      if (_this.listMenuForm.badge[0].badgeType) {
        for (let i = 0; i < _this.listMenuForm.badge.length; i++) {
          if (!_this.listMenuForm.badge[i].badgeType) {
            this.dialogVisible = true;
            this.$propMessage("请選擇徽章", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else if (!_this.listMenuForm.badge[i].badgeLevel) {
            this.dialogVisible = true;
            this.$propMessage("選擇徽章後請選擇徽章等級", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else {
            badgeId.push(_this.listMenuForm.badge[i].badgeLevel);
            param = {
              ...param,
              badgeId: badgeId.toString()
            };
          }
        }
      }
      //状态
      if (_this.listMenuForm.selectStatus) {
        param = {
          ...param,
          status: Number(_this.listMenuForm.selectStatus)
        };
      }
      if (_this.listMenuForm.selectArea) {
        param = {
          ...param,
          district: Number(_this.listMenuForm.selectArea),
          address: _this.listMenuForm.areaDetail
            ? _this.listMenuForm.areaDetail
            : null
        };
      }
      if (_this.listMenuForm.isBlack) {
        param = {
          ...param,
          blackList: Number(_this.listMenuForm.isBlack)
        };
      }
      if (_this.sortValue !== "") {
        param = {
          ...param,
          [_this.sortType]: _this.sortValue
        };
      }
      _this
        .$post(
          `/request/apply/adjust/selection/list?page=${_this.currentPage}&size=${_this.currentPageSize}`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.total = res.data.allRow;
            _this.drawDetail = {
              applyName: res.data.applyName,
              totalNum: res.data.totalNum,
              registration: res.data.registration,
              selectionNumber: res.data.selectionNumber,
              applyStatus: res.data.applyStatus,
              applyWay: res.data.applyWay,
              beSelectedNumber: res.data.beSelectedNumber
            };
            _this.free = res.data.free;
            _this.tableData = res.data.list;
            if (!_this.BadgeoptionsSum.length) {
              _this.BadgeInit();
            }
          } else {
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
          }
        });
    },

    BadgeoptionsChange(item, index) {
      let currentlist = [];
      this.BadgeoptionsSum.map(ite => {
        if (ite.name == item) currentlist = ite.detailDtoList;
      });
      this.BadgeLeveloptions[index] = currentlist;
      this.listMenuForm.badge[index].badgeLevel = "";
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      (this.listMenuForm = {
        userEmail: "",
        time1: "",
        time2: "",
        badge: [
          {
            badgeLevel: "",
            badgeType: ""
          }
        ],
        selectStatus: "",
        selectArea: "",
        areaDetail: "",
        isBlack: ""
      }),
        (this.BadgeLeveloptions = [{}]);
      this.getList();
    },
    navigatetoDetail(item) {
      this.isActivate = true;
      this.$router.push(`/activityDrawDetail?id=${item.id}`);
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.getList();
    },
    handleSelect(selection, row) {
      //选中行长度大于0并且当前行在选中行中 checkedTrue为true
      let checkedTrue = selection.length && selection.indexOf(row) !== -1;

      if (!checkedTrue) {
        // 取消勾选,使用filter()方法过滤掉刚刚勾选的那一条数据
        this.checkboxList = this.checkboxList.filter(item => item.id != row.id);
      }
      if (checkedTrue) {
        // 勾选，将刚刚勾选的数据用push()方法放进数组
        this.checkboxList.push(row);
      }
    },
    selectAll(selection) {
      // selection 为当前页面的勾选数组
      if (selection.length > 0) {
        // 全选，将本页面所有（可以勾选的）数据放入自定义的勾选数组里
        const uniqueArray = selection.filter(item1 => {
          return !this.checkboxList.some(item2 => item2.id === item1.id);
        });
        this.checkboxList.push(...uniqueArray);
      } else {
        // 取消全选，将本页面所有（可以勾选的）数据用filter()＋every()方法过滤掉
        this.checkboxList = this.checkboxList.filter(
          item => this.tableData.every(it => it.id != item.id)
          // every方法，数组里面所有数据为真则返回真
        );
      }
    },
    showTipModal(res) {
      this.showKey = res;
      if (res == "back") {
        this.showTip =
          "返回重新抽選將不會把本頁面更新的報名狀態及任何操作進行保留。";
        this.showTip2 = "是否確認要返回重新抽選？";
      } else if (res == "in") {
        if (!this.checkboxList.length) {
          this.$Mint.Toast("請選擇報名記錄");
          return;
        }
        this.showTip =
          "是否將勾選的" + this.checkboxList.length + "項的報名狀態為已抽中？";
      } else if (res == "out") {
        if (!this.checkboxList.length) {
          this.$Mint.Toast("請選擇報名記錄");
          return;
        }
        this.showTip =
          "是否將勾選的" + this.checkboxList.length + "項報名狀態為未抽中？";
      } else if (res == "update") {
        let current = this.drawDetail.selectionNumber
          ? this.drawDetail.selectionNumber
          : 0;
        this.showTip = "當前已抽中人數：" + current + "人";
      }
      this.confirmshow = true;
    },
    confirmShowModal() {
      if (this.showKey == "back") {
        this.$get(
          `/request/apply/reselection?applyId=${this.$route.query.id}`
        ).then(res => {
          this.confirmshow = false;
          if (res.code == "00000") {
            this.$get(
              `/request/apply/getApplyStatus?applyId=${this.$route.query.id}`
            ).then(result => {
              if (result.code == "00000") {
                this.$router.replace(
                  `/activityDrawFirst?id=${this.$route.query.id}&selectionType=${result.data.selectionType}`
                );
              } else {
                this.dialogVisible = true;
                this.$propMessage(result.message, "error", () => {
                  this.dialogVisible = false;
                });
              }
            });
          } else {
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
          }
        });
      } else if (this.showKey == "in") {
        let list = [];
        this.checkboxList.forEach(item => {
          list.push(item.id);
        });
        let param = {
          applyId: this.$route.query.id,
          status: 1,
          list
        };
        this.$post(
          `/request/apply/update/application/status`,
          param,
          this.$GLOBAL.jsonConfig
        ).then(res => {
          if (res.code == "00000") {
            this.confirmshow = false;
            this.dialogVisible = true;
            this.$propMessage("報名狀態更新成功", "success", () => {
              this.checkboxList = [];
              this.getList();
              this.dialogVisible = false;
            });
          } else {
            this.confirmshow = false;
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.checkboxList = [];
              this.dialogVisible = false;
            });
          }
        });
      } else if (this.showKey == "out") {
        let list = [];
        this.checkboxList.forEach(item => {
          list.push(item.id);
        });
        let param = {
          applyId: this.$route.query.id,
          status: 0,
          list
        };
        this.$post(
          `/request/apply/update/application/status`,
          param,
          this.$GLOBAL.jsonConfig
        ).then(res => {
          if (res.code == "00000") {
            this.confirmshow = false;
            this.dialogVisible = true;
            this.$propMessage("報名狀態更新成功", "success", () => {
              this.getList();
              this.dialogVisible = false;
            });
            this.checkboxList = [];
          } else {
            this.confirmshow = false;
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
            this.checkboxList = [];
          }
        });
      } else if (this.showKey == "update") {
        if (this.free == 1) {
          if (this.paytime) {
            let params = {
              applyId: this.$route.query.id,
              orderOutTime: this.$formatDate(this.paytime)
            };
            this.$post(
              `/request/apply/confirm/update`,
              params,
              this.$GLOBAL.jsonConfig
            ).then(res => {
              if (res.code == "00000") {
                this.$bus.$emit("activityDrawinitList");
                this.$bus.$emit("activityDrawConfirminit");
                this.confirmshow = false;
                this.$router.replace(
                  `/activityDrawConfirmList?id=${this.$route.query.id}`
                );
              } else {
                this.dialogVisible = true;
                this.$propMessage(res.message, "error", () => {
                  this.dialogVisible = false;
                });
              }
            });
          } else {
            this.dialogVisible = true;
            this.$propMessage("請選擇付款結束時間", "error", () => {
              this.dialogVisible = false;
            });
          }
        } else {
          let params = {
            applyId: this.$route.query.id
          };
          this.confirmshow = false;
          this.$post(
            `/request/apply/confirm/update`,
            params,
            this.$GLOBAL.jsonConfig
          ).then(res => {
            if (res.code == "00000") {
              this.$bus.$emit("activityDrawinitList");
              this.$bus.$emit("activityDrawConfirminit");
              this.$router.replace(
                `/activityDrawConfirmList?id=${this.$route.query.id}`
              );
            }
          });
        }
      }
    },
    selectAreaChange(item) {
      this.listMenuForm.areaDetail = "";
    },
    //需要跨页全排，前端做不了要后端支持
    handleSortChange({ column, prop, order }) {
      if (prop == "num") {
        this.sortType = "numOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "vipStartTime") {
        this.sortType = "vipStartTimeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "vipEndTime") {
        this.sortType = "vipEndTimeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "annualSelectNum") {
        this.sortType = "annualOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "sameTypeSelectNum") {
        this.sortType = "sameTypeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      }
      setTimeout(() => {
        this.getList();
      }, 50);
    }
  },
  components: {
    DiaMess
  },
  watch: {
    tableData: {
      deep: true,
      handler(newValue, oldValue) {
        const arr = newValue.filter(
          item => this.checkboxList.some(it => it.id === item.id)
          // some()方法，数组里有一个为真则返回真
        );
        this.$nextTick(() => {
          // 要用nextTick(()={})去更新页面
          arr.forEach(row => {
            // 将数据进行回显
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-table th {
  overflow: visible;
}
.content {
  .el-icon-circle-plus-outline {
    font-size: 20px;
    cursor: pointer;
  }
  .el-icon-circle-plus-outline::before {
    position: relative;
    top: 2px;
  }
  .paddingContent {
    width: 100%;
    // overflow: auto;
    .activityDrawListHeader {
      display: flex;
      align-items: center;
      .activityDrawListHeader_title {
        font-size: 20px;
        color: rgba(108, 61, 234, 1);
        line-height: 26px;
      }
      .activityDrawListHeader_detail {
        display: flex;
        align-items: center;
        .activityDrawListHeader_detail_key {
          margin-left: 24px;
          font-size: 14px;
          color: rgba(147, 142, 164, 1);
        }
        .activityDrawListHeader_detail_value {
          font-size: 14px;
          color: rgba(41, 41, 41, 1);
        }
      }
    }
    .activityDrawListSearch {
      margin-top: 35px;
      width: 100%;
      .ListMenu {
        display: flex;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
        margin-top: 2px;
      }
      .MenuBtnWrap_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 16px;
      }
    }
    .activityDrawListTag {
      background: rgba(250, 250, 253, 1);
      display: flex;
      align-items: center;
      padding: 16px;
      border-radius: 5px;
      margin-top: 26px;
      .activityDrawListTag_detail_key {
        margin-left: 24px;
        font-size: 14px;
        color: rgba(147, 142, 164, 1);
      }
      .activityDrawListTag_detail_value {
        font-size: 17px;
        color: rgba(41, 41, 41, 1);
      }
    }
    .activityDrawListTable {
      background: rgba(250, 250, 253, 1);
      border-radius: 5px;
      margin-top: 10px;
      .statusbar {
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .statusbar_left {
          display: flex;
          align-items: center;
          div {
            font-size: 14px;
          }
          div:nth-child(1) {
            color: rgba(41, 41, 41, 1);
          }
        }
        .statusbar_right {
          display: flex;
          align-items: center;
          div:nth-child(1) {
            background: none;
            color: rgba(105, 62, 221, 1);
            border: 1px solid rgba(105, 62, 221, 1);
            margin-right: 23px;
          }
          div:nth-child(2) {
            background: none;
            color: rgba(105, 62, 221, 1);
            border: 1px solid rgba(105, 62, 221, 1);
            margin-right: 23px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityDraw.vue